import axios from "axios";
import { toast } from "react-toastify";

import authHeader from "./auth-header";

export const fetchGenerateRefid = () => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/cvletter/generate-refid`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchAllCvletters = (filters = {}) => {
  const query_string = new URLSearchParams(filters).toString();
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/cvletter?${query_string}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchOneCvletter = (id) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/cvletter/${encodeURIComponent(id)}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const createCvletter = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/cvletter/`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const updateCvletter = (id, data) => {
  return axios
    .put(`${process.env.REACT_APP_BASE_URL}/cvletter/${encodeURIComponent(id)}`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const deleteCvletter = (id) => {
  return axios
    .delete(`${process.env.REACT_APP_BASE_URL}/cvletter/${encodeURIComponent(id)}`, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

// CVLetter Detail Services
export const fetchAllCvletterDetails = (filters = {}) => {
  const query_string = new URLSearchParams(filters).toString();
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/cvletterdetail?${query_string}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchOneCvletterDetail = (id) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/cvletterdetail/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const createCvletterDetail = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/cvletterdetail/`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const updateCvletterDetail = (id, data) => {
  return axios
    .put(`${process.env.REACT_APP_BASE_URL}/cvletterdetail/${id}`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const deleteCvletterDetail = (id) => {
  return axios
    .delete(`${process.env.REACT_APP_BASE_URL}/cvletterdetail/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const printCvletter = (id, withRecon = false) => {
  const params = new URLSearchParams();
  if (withRecon) {
    params.append('withRecon', 'true');
  }
  
  const url = `${process.env.REACT_APP_BASE_URL}/cvletter/print/${encodeURIComponent(id)}${params.toString() ? '?' + params.toString() : ''}`;
  
  return axios
    .get(url, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};
